import { handleError, ErrorConstants } from 'services/ErrorService/ErrorService';
import { SET_CONVERSATION_BLOCKED_WORDS_FOUND, SET_CONVERSATION_OVERRIDABLE_WORDS_FOUND } from './types';
import { clearBusinessAlerts } from './searchActions';
import { startOnloadLiveQuery, refreshTickets, loadDefaultParseConfigs } from './index';

export const handleConversationLoading = (liveQueryStarted, searchString) => {
  return async (dispatch) => {
    try {
      dispatch(clearBusinessAlerts());
      if (!liveQueryStarted) {
        dispatch(startOnloadLiveQuery());
      }
      !searchString && (await dispatch(refreshTickets()));
      dispatch(loadDefaultParseConfigs());
    } catch (error) {
      handleError({ error, showPopup: true, customMessage: ErrorConstants.defaultErrorRequestProblem });
    }
  };
};

/**
 * Sets state.conversation.blockedWordsFound.
 * @param {string[]} payload - List of blocked words, names and/or aliases found in conversation message.
 */
export const setConversationBlockedWordsFound = (payload) => ({
  type: SET_CONVERSATION_BLOCKED_WORDS_FOUND,
  payload,
});

/**
 * Sets state.conversation.overridableWordsFound.
 * @param {string[]} payload - List of overridable words, names, and/or alliases found in conversation message.
 */
export const setConversationOverridableWordsFound = (payload) => ({
  type: SET_CONVERSATION_OVERRIDABLE_WORDS_FOUND,
  payload,
});
